import React, { FC, useRef, useState } from 'react'
import SwapInput from '../../swap/SwapInput'
import styled from 'styled-components'
import { StepButton } from '../../catalog/StepButton'
import { createEarnTabEvent } from 'user-events-segment'
import { Amounts } from '../../../logic/token/amounts'
import { InjectedWindow } from '../../../utils/types'

declare const window: InjectedWindow

export interface Props {
  onPercentChange: (percent: number) => void
  percent: number | undefined
}

function isValidPercent(percent: number | undefined) {
  return percent !== undefined && percent > 0 && percent <= 100
}

export const WithdrawInput: FC<Props> = (props: Props) => {
  const { percent, onPercentChange } = props
  const [validText, setValidText] = useState(
    isValidPercent(percent) ? percent!.toString() : ''
  )

  function handleChange(text: string) {
    const value: number = Number(text)
    if (text.length > 3) {
      return
    }
    if (isNaN(value)) {
      return
    }

    if (value < 0 || value > 100) {
      return
    }
    setValidText(text)
    onPercentChange(value)
  }

  function handleStep(value: string) {
    handleChange(value)
    createEarnTabEvent(
      window.applicationContext.selectedPool
    ).clicked_percentage_withdraw(parseInt(value))
  }

  return (
    <WithdrawInputWrapper>
      <div>
        <SwapInput
          autoFocus
          small={true}
          onFocus={e => e.target.select()}
          onChange={e => {
            handleChange(e.target.value)
            if (e.target.value) {
              createEarnTabEvent(
                window.applicationContext.selectedPool
              ).entered_percentage_withdraw(parseInt(e.target.value))
            }
          }}
          placeholder={'0'}
          value={validText}
        />
        <span className={'percent'}>%</span>
      </div>
      <span style={{ width: '2rem' }} />
      <div style={{ display: 'flex' }}>
        <StepButton
          value={'25'}
          text={'25 %'}
          onClick={() => handleStep('25')}
        />
        <StepButton
          value={'50'}
          text={'50 %'}
          onClick={() => handleStep('50')}
        />
        <StepButton
          value={'75'}
          text={'75 %'}
          onClick={() => handleStep('75')}
        />
        <StepButton
          value={'100'}
          text={'Max'}
          onClick={() => handleStep('100')}
        />
      </div>
    </WithdrawInputWrapper>
  )
}

const WithdrawInputWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  input {
    font-size: 46px;
    width: 80px;
    text-align: right;
  }
  span.percent {
    font-size: 46px;
    width: 80px;
  }
`
